import { useCallback, useState, useEffect } from 'react';

import { EPaymentProvider } from '../../../../../../contracts';
import { BraintreeCard } from '../BraintreeCard/BraintreeCard';
import { usePaymentState } from '../../../../hooks/use-payment-state';
import { useBraintreeSavedCard } from '../../hooks/use-braintree-saved-card-submit';
import { SavedCardsContainer } from '../../../SavedCardContainer/SavedCardContainer';
import { logPerformance } from '../../../../../../utils/performance-utils';
import { apmLatencyTracker } from '../../../../../../utils/apm-latency-tracker';
import { useCheckout } from '../../../../../../hooks/use-checkout';

export function BraintreeCardContainer() {
  const { selectedPaymentMethod } = useCheckout();
  const savedCards = usePaymentState((state) => state.savedCards);
  const hasSavedCards = Boolean(
    savedCards.filter((card) => card.paymentProvider === EPaymentProvider.braintree).length
  );
  const [savedCardFlow, setSavedCardFlow] = useState({
    show: hasSavedCards,
    defaultSavedCardChecked: false,
  });
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);
  const { handleSubmit } = useBraintreeSavedCard();

  useEffect(() => {
    try {
      apmLatencyTracker.startTracking('Braintree', selectedPaymentMethod?.id);
    } catch (error) {
      console.error('Failed to start APM latency tracking:', error);
    }
  }, [selectedPaymentMethod?.id]);

  const onReady = useCallback(() => {
    setIsApmLoading(false);
    setIsPaymentElementLoading(false);
    logPerformance('Card Component');

    try {
      apmLatencyTracker.endTracking('Braintree', selectedPaymentMethod?.id, {
        paymentMethodName: selectedPaymentMethod?.paymentMethodName,
        paymentMethodDisplayName: selectedPaymentMethod?.paymentMethodDisplayName,
        provider: 'Braintree',
      });
    } catch (error) {
      console.error('Failed to end APM latency tracking:', error);
    }
  }, [setIsPaymentElementLoading, setIsApmLoading, selectedPaymentMethod]);

  const showCardFlow = () => {
    setSavedCardFlow({ show: false, defaultSavedCardChecked: true });
  };

  if (savedCardFlow.show) {
    return (
      <SavedCardsContainer
        onReady={onReady}
        paymentProvider={EPaymentProvider.braintree}
        onPayClicked={handleSubmit}
        showCardFlow={showCardFlow}
        isSecurityCodeRequired={false}
      />
    );
  }
  return (
    <BraintreeCard
      onReady={onReady}
      savedCardProps={{
        defaultSaveCardChecked: savedCardFlow.defaultSavedCardChecked,
        onBackButtonClicked: () => setSavedCardFlow({ show: true, defaultSavedCardChecked: false }),
        showBackButton: hasSavedCards,
      }}
    />
  );
}
